"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_DYNAMIC_TOP_TRENDING = exports.GET_TOP_TRENDING = void 0;
exports.GET_TOP_TRENDING = `
  {
    trendingArticles
  }
`;
exports.GET_DYNAMIC_TOP_TRENDING = `
  query dynamicTrendingArticles($isBlogs: Boolean) {
    dynamicTrendingArticles(isBlogs: $isBlogs)
  }
`;
//# sourceMappingURL=trending-across-queries.js.map